module.exports = __webpack_public_path__ + "img/t.36a0040a.svg";